import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { useSelector } from "react-redux";
import CreateEditContent from "./CreateEditContent";
import { SLEditModal } from "~/pages/Sistema/componentes/SistemaList";

export default function DashboardProjeto() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);
  const [anos, setAnos] = useState([]);
  const [anoAtivo, setAnoAtivo] = useState(new Date().getFullYear());
  const [clientes, setClientes] = useState([]);
  const [clienteFiltro, setClienteFiltro] = useState();
  const [etapas, setEtapas] = useState([]);
  const [idsEtapa, setIdsEtapa] = useState([]);
  const [coordenadores, setCoordenadores] = useState([]);
  const [idCliente, setIdCliente] = useState();
  const [idCoordenador, setIdCoordenador] = useState();
  const [titulo, setTitulo] = useState();

  useEffect(() => {
    setLoadedData(false);
  }, [idCliente, idsEtapa, idCoordenador, titulo]);

  useEffect(() => {
    async function handleRequests() {
      api.get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));

      api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
        .then(response => setClientes(response.data));

      api.get("/signed/empresa/gestorprojeto/etapa/etapas", { params: { ativo: 1, tipo: 'PRJ' } })
        .then(response => setEtapas(response.data));

      api.get("/signed/empresa/gestorprojeto/gerencia/coordenadores", { params: { ativo: 1 } })
        .then(response => setCoordenadores(response.data));

      setAnos([
        { id: new Date().getFullYear() - 2 },
        { id: new Date().getFullYear() - 1 },
        { id: new Date().getFullYear() },
      ])
    }

    handleRequests();
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get(
                  '/signed/empresa/gestorprojeto/relatorios/relatorioprojetos',
                  { params: { idCliente, ano: anoAtivo, idEtapa: idsEtapa, titulo, idCoordenador } },
                ),
              findOne: (thisData) =>
                api.get(
                  '/signed/empresa/gestorprojeto/relatorios/relatorioprojetos/historico',
                  { params: { idProjeto: thisData?.id } },
                ),
            }}
            selects={[
              {
                list: clientes,
                value: "id",
                label: "nomeFantasia",
                outLabel: "Todos os Clientes",
                filter: "idCliente",
                onChange: (idCliente) => {
                  setClienteFiltro(idCliente);
                }
              },
            ]}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Relatório de Projetos',
              subTitle: "Filtre e gere o relatório que precisar",
              icone: 'submenu-relatorio-projeto',
            }}
            manual={true}
          >
            <SLEditModal menu={true} title="Visualizar Histórico Projeto" setter={setMountedData}>
              {mountedData && (
                <CreateEditContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <CustomBodyContent
              {...{
                data, clientes, idCliente, setIdCliente, idsEtapa, setIdsEtapa, titulo,
                setTitulo, coordenadores, idCoordenador, setIdCoordenador
              }}
            />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
